import { computed, observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { Logger, NOOP_LOGGER } from 'bernie-logger';
import {
  FlightsMetricName,
  FlightsShoppingPwaFlightSearchResultsFlightsSearch,
  ResponseTagType
} from '__generated__/api';
import ClientMetadata = FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsPwaMetadataInlineFragment;

export class ClientMetadataStore extends Store {
  @observable public clientMetadata: ClientMetadata;
  @observable public customerNotificationMetrics?: number;
  @observable public env: string;
  @observable public version: string;

  @computed get isCachedResponse(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.LISTING_CACHE_SOURCE == tag);
  }

  @computed get isResponseSummaryLive(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.RESPONSE_SUMMARY_LIVE == tag);
  }

  @computed get isCacheSourceAirBlaze(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.CACHE_SOURCE_AIRBLAZE == tag);
  }

  @computed get isCacheSourceBYOTAirBlaze(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.CACHE_SOURCE_BYOT_AIRBLAZE == tag);
  }

  @computed get isResponseSummaryHybrid(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.RESPONSE_SUMMARY_HYBRID == tag);
  }

  @computed get isResponseSummaryCachedConfig(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.RESPONSE_SUMMARY_CACHED_CONFIG == tag);
  }

  @computed get isResponseSummaryCachedML(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.RESPONSE_SUMMARY_CACHED_ML == tag);
  }

  @computed get isListingsPaginatedSliced(): boolean {
    return this.clientMetadata?.responseTags?.some(tag => ResponseTagType.LISTINGS_PAGINATED_SLICED == tag);
  }

  @computed get supplyOverheadResponseMetricValue(): number {
    const filteredArray = this.clientMetadata?.responseMetrics?.filter(
      metric => FlightsMetricName.LISTINGS_SUPPLY_RESPONSE_TIME == metric.name
    );

    return filteredArray?.length > 0 ? parseInt(filteredArray[0].value) : 0;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }
}
